import styled from 'styled-components';
import Accordion from '../../../CoreWrappers/Accordion';

export default styled(Accordion)`
	.motif-accordion-title-content {
		flex: 1;
	}
`;
